"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _DefaultContent = _interopRequireDefault(require("./DefaultContent"));

var _logoDefault = _interopRequireDefault(require("../../../assets/logo-default.png"));

require("../Footer.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** Use the mini footer when required. */
function FooterMini(_ref) {
  var children = _ref.children,
      link = _ref.link,
      title = _ref.title,
      logo = _ref.logo;
  return /*#__PURE__*/_react.default.createElement("footer", {
    className: "Footer Footer_mini"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container Footer__bottom"
  }, /*#__PURE__*/_react.default.createElement("span", null, children), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: link,
    title: title
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: title
  }))));
}

FooterMini.propTypes = {
  /** @ignore */
  children: _propTypes.default.node,

  /** Logo link */
  link: _propTypes.default.string,

  /** Alternative text for logo image and title attribute for the link */
  title: _propTypes.default.string,

  /** Source for the Logo */
  logo: _propTypes.default.node
};
FooterMini.defaultProps = {
  children: /*#__PURE__*/_react.default.createElement(_DefaultContent.default, null),
  link: '/',
  title: 'additiv AG',
  logo: _logoDefault.default
};
var _default = FooterMini;
exports.default = _default;